const origin = "https://dihaw.co";
type Node = Record<string, unknown>;
const node = (value: unknown): value is Node =>
  Boolean(value && typeof value === "object" && !Array.isArray(value));

// One entity identity for SSR and client navigation. Page-specific facts remain
// sourced from the visible listing, article or FAQ; never infer ratings or stock.
export function searchSchema(
  canonical: string,
  title: string,
  description: string,
  robots: string,
  existing?: unknown,
) {
  if (robots.includes("noindex")) return undefined;
  const raw =
    node(existing) && Array.isArray(existing["@graph"])
      ? existing["@graph"]
      : Array.isArray(existing)
        ? existing
        : [existing];
  const specific = raw
    .filter(node)
    .filter(
      (item) => !["Organization", "WebSite"].includes(String(item["@type"])),
    );
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": origin + "/#organization",
        name: "Dihaw.co",
        url: origin,
        logo: origin + "/favicon-blue.png",
        email: "hello@dihaw.ai",
        description:
          "Platform pencarian dan pemasangan listing properti di Indonesia.",
      },
      {
        "@type": "WebSite",
        "@id": origin + "/#website",
        name: "Dihaw.co",
        url: origin,
        inLanguage: "id-ID",
        publisher: { "@id": origin + "/#organization" },
        potentialAction: {
          "@type": "SearchAction",
          target: origin + "/jual?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "WebPage",
        "@id": canonical + "#webpage",
        url: canonical,
        name: title,
        description,
        inLanguage: "id-ID",
        isPartOf: { "@id": origin + "/#website" },
        publisher: { "@id": origin + "/#organization" },
      },
      ...specific,
    ],
  };
}
